"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessMethodId = void 0;
var access_method_id_1 = require("./access-method-id");
Object.defineProperty(exports, "AccessMethodId", { enumerable: true, get: function () { return access_method_id_1.AccessMethodId; } });
